import { render } from "./appHeader.vue?vue&type=template&id=7aff06e7"
import script from "./appHeader.vue?vue&type=script&lang=js"
export * from "./appHeader.vue?vue&type=script&lang=js"

import "./appHeader.vue?vue&type=style&index=0&id=7aff06e7&lang=css"

import exportComponent from "C:\\Users\\Камиль\\Desktop\\Skillbox\\final_examination_vue.js_dpo\\project\\moire-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__